export default "__VITE_ASSET__eDEjf4fW__"